<template>
  <v-container>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="sucursales"
          :loading="loading"
          sort-by="description"
          class="elevation-1"
        >
          <template v-slot:top>
            <v-toolbar flat>
              <v-toolbar-title>Sucursales</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" persistent max-width="900px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    v-bind="attrs"
                    v-on="on"
                  >
                    Nuevo
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.name"
                            label="Nombre*"
                            :rules="[rules.required]"
                            v-uppercase
                            validate-on-blur
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.description"
                            label="Descripción"
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.telephone"
                            label="Teléfono*"
                            :rules="[rules.required,rules.regex]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.calle"
                            label="Calle*"
                            :rules="[rules.required]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.numero_exterior"
                            label="numero exterior*"
                            :rules="[rules.required]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.colonia"
                            label="Colonia*"
                            :rules="[rules.required]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.city"
                            label="Ciudad*"
                            :rules="[rules.required]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.state"
                            label="Estado*"
                            :rules="[rules.required]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.postal_code"
                            label="Codigo Postal*"
                            maxlength="5"
                            type="tel"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.emisor_nombre"
                            label="Razon Social"
                            :rules="[rules.required,rules.regexRZ]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.emisor_rfc"
                            label="RFC"
                            :maxlength="13"
                            :rules="[rules.required,rules.regexRFC]"
                            validate-on-blur
                            v-uppercase
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.emisor_regimen"
                            label="Regimen Fiscal"
                            v-uppercase
                            maxlength="3"
                            type="tel"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.folio_factura"
                            label="Folio de factura"
                            type="number"
                            :disabled="respaldo.folio_factura ? true : false"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6" md="4">
                          <v-text-field
                            v-model="editedItem.serie_factura"
                            label="Serie de factura"
                            v-uppercase
                            maxlength="3"
                            type="text"
                            :disabled="respaldo.serie_factura ? true : false"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      Cancelar
                    </v-btn>
                    <v-btn :disabled="handleDisabled" color="blue darken-1" text @click="save">
                      Guardar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="headline"
                    >¿Seguro de dar de baja esta Sucursal?</v-card-title
                  >
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >Cancelar</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >Aceptar</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:no-data>
            <!-- <v-btn
              color="primary"
              @click="initialize"
            >
              Reiniciar
            </v-btn> -->
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ApiService from "../../services/apis";
import { validateNoErrors } from "../../helpers/helpers";
import Swal from 'sweetalert2'
export default {
  name: "sucursal",
  data: () => ({
    rules: {
      required: (value) => !!value || "Requerido.",
      regex: (v) => /^\d{10}$/.test(v) || "Deben ser 10 digitos",
      regexRZ: (v) =>
        !/(S.A. DE C.V.)$|(S.A.)$|(S.A.S.)$|(S.A. de C.V.)$|(S. de R.L.)$|(S.C.)$/gi.test(
          v
        ) || "Formato no válido",
      regexRFC: (v) => /^[\da-zA-Z]{12,13}$/gi.test(v) || "Formato no válido",
    },
    loading: false,
    dialog: false,
    dialogDelete: false,
    headers: [
      {
        text: "Nombre",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Descripción", value: "description" },
      { text: "Dirección", value: "address" },
      { text: "Teléfono", value: "telephone" },
      { text: "Ciudad", value: "city" },
      { text: "Estado", value: "state" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    sucursales: [],
    editedIndex: -1,
    editedItem: {
      name: "",
      description: "",
      address: "",
      telephone: "",
      city: "",
      state: "",
      calle:"",
      numero_exterior:"",
      colonia:"",
      serie_factura:null
    },
    respaldo: { folio_factura: null, serie_factura: null },
    defaultItem: {
      name: "",
      description: "",
      address: "",
      telephone: "",
      city: "",
      state: "",
    },
    id: null,
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Alta de nueva Sucursal"
        : "Modificar Sucursal";
    },
    handleDisabled(){
      const {name,city,telephone,calle,numero_exterior,colonia,emisor_nombre,emisor_rfc} = this.editedItem
      const telephoneValid = validateNoErrors("telephones", telephone);
      const nombreValid = validateNoErrors("razonSocial", emisor_nombre);
        const rfcValid = validateNoErrors("rfc", emisor_rfc);
      if(name && city && telephoneValid && calle && numero_exterior && colonia && nombreValid && rfcValid) return false
      return true
    }
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },
  mounted() {},
  methods: {
    async initialize() {
      try {
        this.loading = true;
        const sucursal = await ApiService.sucursal();
        this.sucursales = sucursal.data;
        this.loading = false;
      } catch (err) {
        this.loading = false;
        return err;
      }
    },
    editItem(item) {
      if(item?.serie_factura == "") item.serie_factura = null
      this.editedIndex = this.sucursales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.respaldo = item;
      this.dialog = true;
      this.id = item._id;
    },

    deleteItem(item) {
      this.editedIndex = this.sucursales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
      this.id = item._id;
    },

    async deleteItemConfirm() {
      try {
        this.loading = true
        await ApiService.sucursalEditar(this.id, { status: 0 })
        Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Sucursal eliminada con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
        this.loading = false
        this.sucursales.splice(this.editedIndex, 1);
        this.close();
      this.closeDelete();
      this.id = null;
      } catch (error) {
        this.id = null;
        this.close();
      this.closeDelete();
        this.loading = false
        return error
      }
    },

    close() {
      this.dialog = false;
      this.respaldo = { folio_factura: null, serie_factura: null }
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.id = null;
      });
      // this.initialize();
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.id = null;
      });
    },

    async save() {
      this.loading = true
      if (this.editedIndex > -1) {
        try{
        //Object.assign(this.sucursales[this.editedIndex], this.editedItem)
       await ApiService.sucursalEditar(this.id, this.editedItem)
       Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Sucursal editada con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
          this.close();
          this.loading = false
        }catch(err){
          this.loading = false
          return err
        }
      } else {
        try{
        //this.sucursales.push(this.editedItem)
        await ApiService.sucursalNuevo(this.editedItem)
        Swal.fire({
          icon: "success",
          title: "Atención!",
          text: `Sucursal agregada con éxito`,
          showConfirmButton: true,
          confirmButtonText: "Enterado",
        });
          this.loading = false
          this.close();
      }catch(err){
        this.loading = false
          return err
        }
      }
      this.initialize();
    },
    mayus(e) {
      e.value = e.value.toUpperCase();
    },
  },
};
</script>


